import { render, staticRenderFns } from "./AmazeDashboardIconTile.vue?vue&type=template&id=9be7b260&scoped=true"
import script from "./AmazeDashboardIconTile.vue?vue&type=script&lang=js"
export * from "./AmazeDashboardIconTile.vue?vue&type=script&lang=js"
import style0 from "./AmazeDashboardIconTile.vue?vue&type=style&index=0&id=9be7b260&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9be7b260",
  null
  
)

export default component.exports